import axios from 'axios';
import data from '../config';
import store from "@/vuex/store";

const api = axios.create({ baseURL: data.apiUrl });

const setConfig = config => {
  const token = store.state.token;

  if (token) config.headers.common.Authorization = token;

  return config;
};

const handleError = error => {
  if (!error || !error.response) return;

  const isActionUnauthorized = error.response.status === 401;

  if (isActionUnauthorized) {
  }

  return Promise.reject(error.response);
};

const getRejectedError = error => Promise.reject(error);
const getResponse = response => response && response.data;

api.interceptors.request.use(setConfig, getRejectedError);
api.interceptors.response.use(getResponse, handleError);

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js